import { profileServices } from '@/lib/company-profile';
import { solutions } from '@/lib/site-content';
import { productImages } from '@/lib/product-imagery';

// Equipment families from the supplied company profile, rather than a stock list.
export const catalogueCategories = solutions.map(solution => {
  const profile = profileServices.find(category => category.path === solution.path);
  if (!profile) throw new Error('Missing company-profile category: ' + solution.slug);
  return {
    id: solution.slug,
    title: solution.title,
    path: solution.path,
    topic: solution.title,
    items: profile.items,
  };
});

export const catalogueItems = catalogueCategories.flatMap(category => category.items.map((name, index) => {
  const image = productImages[name];
  if (!image) throw new Error('Missing illustrative product image: ' + name);
  return {
    id: category.id + '-' + index,
    name,
    categoryId: category.id,
    categoryTitle: category.title,
    path: category.path,
    topic: category.topic,
    image,
  };
}));

export function filterCatalogueItems(categoryId: string, query: string) {
  const terms = query.trim().toLocaleLowerCase('en').split(/\s+/).filter(Boolean);
  return catalogueItems.filter(item => {
    const text = (item.name + ' ' + item.categoryTitle).toLocaleLowerCase('en');
    return (categoryId === 'all' || item.categoryId === categoryId) && terms.every(term => text.includes(term));
  });
}

export function catalogueEnquiryPath(item: typeof catalogueItems[number]) {
  return '/contact/?' + new URLSearchParams({ topic: item.topic, equipment: item.name }).toString();
}

export function catalogueEnquiryDraft(search: URLSearchParams) {
  const item = catalogueItems.find(item => item.name === search.get('equipment'));
  return item ? {
    topic: item.topic,
    message: 'I would like a quotation for ' + item.name + '.\nQuantity: \nSpecifications: \nRequired delivery timeframe: ',
  } : null;
}
